import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { REQUEST_API_END_POINT } from '../utils/constant';

// Récupérer toutes les requêtes
export const fetchRequests = createAsyncThunk('requests/fetchRequests', async () => {
    const response = await axios.get(`${REQUEST_API_END_POINT}/all`);
    return response.data;
});

// Récupérer une requête par ID
export const fetchRequestById = createAsyncThunk('requests/fetchRequestById', async (id) => {
    const response = await axios.get(`${REQUEST_API_END_POINT}/${id}`);
    return response.data;
});

// Ajouter une requête
export const addRequest = createAsyncThunk('requests/addRequest', async (newRequest) => {
    const response = await axios.post(`${REQUEST_API_END_POINT}/save`, newRequest).catch((err) => {console.log(err)})
    return response.data;
});

const requestSlice = createSlice({
    name: 'requests',
    initialState: {
        loading: false,
        requests: [],
        singleRequest: null,
        loadingRequests: false, // Loading pour la récupération des requêtes
        loadingSave: false, // Loading pour l'enregistrement d'une requête
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Récupération des requêtes
            .addCase(fetchRequests.pending, (state) => {
                state.loadingRequests = true;
            })
            .addCase(fetchRequests.fulfilled, (state, action) => {
                state.loadingRequests = false;
                state.requests = action.payload;
            })
            .addCase(fetchRequests.rejected, (state, action) => {
                state.loadingRequests = false;
                state.error = action.error.message;
            })

            // Récupération d'une requête par ID
            .addCase(fetchRequestById.pending, (state) => {
                state.loadingRequests = true;
            })
            .addCase(fetchRequestById.fulfilled, (state, action) => {
                state.loadingRequests = false;
                state.singleRequest = action.payload;
            })
            .addCase(fetchRequestById.rejected, (state, action) => {
                state.loadingRequests = false;
                state.error = action.error.message;
            })

            // Ajout d'une requête
            .addCase(addRequest.pending, (state) => {
                state.loadingSave = true;
            })
            .addCase(addRequest.fulfilled, (state, action) => {
                state.loadingSave = false;
                state.requests.push(action.payload);
            })
            .addCase(addRequest.rejected, (state, action) => {
                state.loadingSave = false;
                state.error = action.error.message;
            });
    },
});

export default requestSlice.reducer;
